const distributorCustomerEditing = {
  'Only selected products': 'Solo los productos seleccionados',
  Pricing: 'Precios',
  'Keep at least one product selected, or allow all products.':
    'Mantenga al menos un producto seleccionado o permita todos los productos.',
  'Pricing & ordering': 'Precios y pedidos',
  'Delivery defaults': 'Preferencias de entrega',
  'Customer prices apply to new orders. Credit limits are informational.':
    'Los precios del cliente se aplican a pedidos nuevos. Los límites de crédito son informativos.',
  'Unfinished action': 'Acción sin terminar',
  'New login': 'Nuevo acceso',
  'Edit customer': 'Editar cliente',
  'Save or discard your changes before closing.': 'Guarde o descarte sus cambios antes de cerrar.',
  'Customer details': 'Datos del cliente',
  'Contact email': 'Correo de contacto',
  'Active customer': 'Cliente activo',
  'Save customer details': 'Guardar datos del cliente',
  'Reload customer details': 'Volver a cargar los datos del cliente',
  'Customer details saved.': 'Datos del cliente guardados.',
  'Could not load customer details. Please try again.':
    'No se pudieron cargar los datos del cliente. Inténtelo de nuevo.',
  'Customer details could not be confirmed. Your edits are still here. Reload before saving again.':
    'No se pudieron confirmar los datos del cliente. Sus cambios se conservan. Vuelva a cargar antes de guardar otra vez.',
  'Contact email is separate from login emails and QuickBooks billing email.':
    'El correo de contacto es independiente del correo de inicio de sesión y del correo de facturación de QuickBooks.',
  'Edit login': 'Editar acceso',
  'Edit clinic login': 'Editar acceso de la clínica',
  'Account email': 'Correo de la cuenta',
  'Clinic role': 'Rol en la clínica',
  'Save account': 'Guardar cuenta',
  'Saving login changes signs this account out on all devices. Other logins keep their own credentials.':
    'Al guardar los cambios se cierra la sesión de esta cuenta en todos los dispositivos. Las otras cuentas conservan sus propias credenciales.',
  'Account saved. All prior sessions were revoked.':
    'Cuenta guardada. Se revocaron todas las sesiones anteriores.',
  'Account changes could not be confirmed. Reload the account before trying again. Your edits are still here.':
    'No se pudieron confirmar los cambios de la cuenta. Vuelva a cargarla antes de intentarlo de nuevo. Sus cambios se conservan.',
};

export default distributorCustomerEditing;
